module.exports = __webpack_public_path__ + "9e592b8a0fcca484526e726db1a127e5.svg";